// src/components/molecules/Sidebar/Sidebar.tsx
import React from 'react';
import { Link } from '@tanstack/react-router';
import {
  IconButton,
  Row,
  Col,
  AccountIcon,
  StarIcon,
  UserIcon,
  ListCheckIcon,
} from 'shared-portal-component';

import '@/components/molecules/Sidebar/Sidebar.scss';

export type NavKey = 'account' | 'administrators' | 'users' | 'activity-log';

export interface SidebarItem {
  key: NavKey;
  label: string;
  icon?: React.ReactElement;
  href: string;
}

interface SidebarProps {
  className?: string;
}

const ITEMS: SidebarItem[] = [
  { key: 'account',        label: 'Account Overview', href: '/admin/account',        icon: <AccountIcon size="lg" /> },
  { key: 'administrators', label: 'Administrators',   href: '/admin/administrators', icon: <StarIcon size="lg" /> },
  { key: 'users',          label: 'Users',            href: '/admin/users',          icon: <UserIcon size="lg" /> },
  { key: 'activity-log',   label: 'Activity Log',     href: '/admin/activity-log',   icon: <ListCheckIcon size="lg" /> },
];

const Sidebar: React.FC<SidebarProps> = ({ className = '' }) => (
  <aside className={`admin-sidebar ${className}`}>
    <nav className="admin-sidebar__nav" aria-label="Admin navigation">
      <ul>
        {ITEMS.map((item) => (
          <li key={item.key}>
          <Link
  to={item.href}
  activeOptions={{ exact: true }}
  className="admin-sidebar__link cursor-pointer"
  activeProps={{ className: 'is-active', 'aria-current': 'page' }}
>
  <Row
    spacing="none"
    justify="between"
    align="center"
    className="sidebar-link-row"
  >
    <Col size={3}>
      <IconButton
        icon={item.icon ?? <span />}
        ariaLabel={item.label}
        size="md"
        type="button"
        className="admin-sidebar__icon"
      />
    </Col>
    <Col>
      <p className="text-left label">{item.label}</p>
    </Col>
  </Row>
</Link>
          </li>
        ))}
      </ul>
    </nav>
  </aside>
);

export default Sidebar;
